import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ReactGA from 'react-ga';
import ConfigurationManager from './configuration/ConfigurationManager';

import { I18nProvider } from './I18nProvider';

console.log('App Loaded');
export const initGA = () => {       
  ReactGA.initialize(ConfigurationManager.getProperty('GA_TRACKING_CODE'));
} 

export const GAPageView = (page) => {
  ReactGA.pageview(page);
}

export const GAModalView = (modal) => {
  ReactGA.modalview(modal);
}
ReactDOM.render(
    <MuiPickersUtilsProvider utils={MomentUtils}>
    <I18nProvider>
      <App />
    </I18nProvider>
  </MuiPickersUtilsProvider>, document.getElementById('root'));



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
